import React, { useState, useEffect } from "react";
import { FormControlLabel, Radio } from "@mui/material";
import { useTranslation } from "react-i18next";
import { UiCustomPopup } from "./common/UiModal";
import { SomethingWrongModal } from "./Popups/SomethingWrongModal";
import { ConfirmationIcon } from "../../styles/img/svg/ConfirmationIcon";
import UiRadioInput from "./common/UiRadioInput";

import { commonConstants } from "../../_redux/_constants";

const UiCountdownTimer = (props) => {
  const { userDetails } = props;
  const { t, i18n } = useTranslation();
  const [timeLeft, setTimeLeft] = useState(props.timer);
  const [enableOtpBtn, setEnableOtpBtn] = useState(false);
  const [enableSelection, setEnableSelection] = useState(false);
  const [otpSendMethod, setOtpSendMethod] = useState(false);
  const [userSelectedButton, setUserSelectedButton] = useState(false);
  const [countdownKey, setCountdownKey] = useState(0);

  const openCloseOTPSelection = (param) => {
    setEnableSelection(param);
  };

  const otpMethodSelection = (type) => {
    setOtpSendMethod(type);
    setUserSelectedButton(true);
  };

  useEffect(() => {
    setCountdownKey((prev) => prev + 1);
  }, [props?.timer]);

  useEffect(() => {
    setEnableOtpBtn(false);
    setTimeLeft(props.timer);

    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setEnableOtpBtn(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [countdownKey]);

  const resendOTPResetFunc = () => {
    if (userDetails?.email && userDetails?.phone1) {
      if (typeof props?.hideMainModal === "function") {
        props.hideMainModal();
      }
      // Reset selection state each time before showing the chooser
      setOtpSendMethod(false);
      setUserSelectedButton(false);
      openCloseOTPSelection(true);
    } else {
      openCloseOTPSelection(false);
      setEnableOtpBtn(false);
      setCountdownKey((prev) => prev + 1);
      if (userDetails?.email || !userDetails?.phone1) {
        props?.otpResend(commonConstants.OTP_SEND_METHOD_TYPE_EMAIL);
      } else {
        props?.otpResend(commonConstants.OTP_SEND_METHOD_TYPE_SMS);
      }
    }
  };

  const sendOTPBySelection = () => {
    if (otpSendMethod) {
      openCloseOTPSelection(false);
      if (typeof props?.showMainModal === "function") {
        props.showMainModal();
      }

      setCountdownKey((prev) => prev + 1);
      setEnableOtpBtn(false);
      props?.otpResend(otpSendMethod);
    }
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0",
    )}`;
  };

  const showTime = formatTime(timeLeft);

  const showTimeText =
    timeLeft >= 60 ? "minutes to resend OTP" : "secs to resend OTP";

  return (
    <>
      <div className="df-timer-countdown">
        <p className="df-timer-countdown__timer">
          {t(showTimeText, { time: showTime })}
        </p>

        <div className="d-flex">
          <p className="mb-0 df-timer-countdown__otp-resend-txt">
            {t("Didn’t receive the OTP Number?")} 

            {enableOtpBtn ? (
              <button className="df-resend" onClick={resendOTPResetFunc}>
                {" "}
                {t("Resend OTP")}{" "}
              </button>
            ) : (
              <button className="df-resend" disabled>
                {" "}
                {t("Resend OTP")}{" "}
              </button>
            )}
          </p>
        </div>
      </div>

      <UiCustomPopup
        openModal={enableSelection}
        handleClose={() => {
          openCloseOTPSelection(false);
          if (typeof props?.showMainModal === "function") {
            props.showMainModal();
          }
        }}
        showCloseIcon
        className="df-countdown-pp"
      >
        <SomethingWrongModal
          icon={<ConfirmationIcon />}
          buttonOnClick={sendOTPBySelection}
          buttonText={t("Send")}
          className="df-confirmation-message-popup df-resend-otp-modal"
          buttonClass="df-ui-dark-bg-btn "
          disabled={!userSelectedButton}
        >
          <h2>{t("Resend OTP")}</h2>
          <p>{t("Select delivery method for the OTP")}</p>

          <UiRadioInput
            className="df-custom-radio"
            formControlClass="w-100"
            name="accounts-seclect-group"
          >
            <FormControlLabel
              onClick={() => {
                otpMethodSelection(commonConstants.OTP_SEND_METHOD_TYPE_SMS);
              }}
              value="1"
              control={<Radio />}
              label={t("SMS")}
            />
            <FormControlLabel
              onClick={() => {
                otpMethodSelection(commonConstants.OTP_SEND_METHOD_TYPE_EMAIL);
              }}
              value="2"
              control={<Radio />}
              label={t("Email")}
            />
          </UiRadioInput>
        </SomethingWrongModal>
      </UiCustomPopup>
    </>
  );
};

export default UiCountdownTimer;
